import { AmazonRegion } from '@domain/connection/IMarketplaceRepository';

const STORAGE_KEY = 'amazon-oauth';

export interface AmazonOAuthIntent {
  region: AmazonRegion;
  connectionId?: string;
  returnPath: string;
}

export function saveAmazonOAuthIntent(intent: AmazonOAuthIntent): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
}

export function readAmazonOAuthIntent(): AmazonOAuthIntent | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as AmazonOAuthIntent;
    if (parsed.region !== 'eu' && parsed.region !== 'na' && parsed.region !== 'fe') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearAmazonOAuthIntent(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

/** Amazon's confirm URL must stay on an Amazon host. */
export function isAmazonConfirmUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:'
      && /(^|\.)amazon\.[a-z.]+$/.test(url.hostname)
      && url.pathname.startsWith('/apps/authorize/confirm');
  } catch {
    return false;
  }
}

export function buildAmazonConfirmUrl(
  amazonCallbackUri: string,
  amazonState: string,
  state: string,
  redirectUri: string,
  version?: string | null,
): string {
  const url = new URL(amazonCallbackUri);
  url.searchParams.set('amazon_state', amazonState);
  url.searchParams.set('state', state);
  url.searchParams.set('redirect_uri', redirectUri);
  if (version === 'beta') url.searchParams.set('version', 'beta');
  return url.toString();
}

export function disableReferrer(): void {
  let meta = document.querySelector('meta[name="referrer"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', 'no-referrer');
}
